import { useEffect, useState } from "react";
import { fileServices } from "../Media/FileManager/fileServices";
import { Box, Card, ImageList, ImageListItem, ImageListItemBar, Typography } from "@mui/material";
import Swal from "sweetalert2";

const SduiGuidelines = () => {
    const [guidelinesFiles, setGuidelinesFiles] = useState([]);
    const fetchGuidelinesFiles = async () => {
        Swal.fire({
            title: 'Loading SDUI Guidelines...',
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });
        const response = await fileServices.fetchFolderContent('guidelines');
        if(response.success == '1'){
            setGuidelinesFiles(response.data.files || []);
            Swal.close();
        } else {
            Swal.fire({
                title: 'Error',
                text: 'Failed to load guidelines files.',
                icon: 'error'
            });
        }

    }
    useEffect(()=>{
        fetchGuidelinesFiles();
    },[])

    const handleImageClick = (url) => {
        window.open(url, '_blank', 'noopener,noreferrer');
    }

    return (
        <Card sx={{ p: { xs: 2, md: 4 } ,minHeight:"50vh", maxHeight:'74vh', overflowY: 'auto' }}>

            
            {/* <Typography variant="h5" sx={{ mb: 3 }}>SDUI Guidelines</Typography> */}
            { guidelinesFiles && guidelinesFiles.length > 0 ?
                <Box sx={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(4, 1fr)',
                    gap: 2,
                    '& img': {
                        width: '100%',
                        height: 200,
                        objectFit: 'cover',
                        borderRadius: 2,
                        cursor: 'pointer',
                        border: '1px solid #ddd',
                        '&:hover': {
                            borderColor: '#aaa',
                        }
                    }
                }}>
                    { 
                    
                        guidelinesFiles.map((file, index) => (
                            <Box key={index} onClick={() => handleImageClick(file.url)}>
                                <img src={file.url} alt={file.fileName} loading="lazy" />
                                <Typography variant="caption" display="block" sx={{ mt: 0.5 }}>
                                    {file.fileName}
                                </Typography>
                            </Box>
                    )) }
                </Box>
                :(
                    <Box sx={{ display: 'flex', justifyContent: 'center',flexDirection: 'column', alignItems: 'center', height: '50vh' }}>
                        <Typography variant="body2" color="text.secondary" >
                            No guidelines files available.
                        </Typography>
                    </Box>
                )
            }
        </Card>
    );
}

export default SduiGuidelines;
